var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c(
        "div",
        {
          staticClass: "card-header",
          attrs: { "aria-expanded": _vm.active, role: "tab" },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: `#${_vm.itemId}`,
                "aria-controls": `content-${_vm.itemId}`,
                "data-toggle": "collapse",
                "data-parent": "#accordion",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.activate.apply(null, arguments)
                },
              },
            },
            [
              _vm._t("title", function () {
                return [_vm._v(" " + _vm._s(_vm.title) + " ")]
              }),
              _c("i", { staticClass: "tim-icons icon-minimal-down" }),
            ],
            2
          ),
        ]
      ),
      _c(
        "collapse-transition",
        { attrs: { duration: _vm.animationDuration } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.active,
                  expression: "active",
                },
              ],
              staticClass: "collapsed",
              attrs: {
                id: `content-${_vm.itemId}`,
                "aria-labelledby": _vm.title,
                role: "tabpanel",
              },
            },
            [_c("div", { staticClass: "card-body" }, [_vm._t("default")], 2)]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }